// extracted by mini-css-extract-plugin
export default {"notifications":"styles_notifications__jJ5X","header":"styles_header_WdgWi"};